import {Map, Marker, TileLayer, Icon} from 'leaflet';
import {template} from "./helpers";

export default class Contact {
    constructor() {
        this.buildMap();
        this.contactForm();
    }

    buildMap() {
        this.map = new Map('map', {
            center: [46.86770273172814, 2.3510742187500004],  // France GPS coordinates
            zoom: 2,
            //minZoom: 2,
            //maxZoom: 6,
            attributionControl: false,
            scrollWheelZoom: false
        });

        new TileLayer('https://api.mapbox.com/styles/v1/{username}/{styleId}/tiles/{tileSize}/{z}/{x}/{y}?access_token={accessToken}', {
            username: 'cc-metrolog',
            styleId: 'cjlcaoo9i354a2sl4opibn7q7',
            tileSize: 256,
            accessToken: window.Metrolog.MAPBOX_ACCESS_TOKEN,
        }).addTo(this.map);

        let customIcon = new Icon({
            iconUrl: '/app/themes/metrolog/assets/img/marker.png',
            iconSize: [32, 32]
        });

        window.Metrolog.sites.forEach((site) => {

            let marker = new Marker(
                [site.lat, site.lng],
                {icon: customIcon}
            );
            marker.bindPopup(template('map-popup-template', site));
            marker.addTo(this.map)
        });
    }

    contactForm() {
        let formContact  = document.getElementById('form-contact');
        formContact.classList.add('d-none');
        window.addEventListener("scroll", () => {
            formContact.classList.remove('d-none');
        });
    }
}